import React, { Fragment } from 'react';
import { DESKTOP_MAP_SEARCH_LIMIT, MOBILE_MAP_SEARCH_LIMIT } from 'config';
import SearchResultFetcher from 'components/SearchResultFetcher';
import { FixedPageWrapper, MapWrapper } from './primitives';
import MapSearchHelmet from './MapSearchHelmet';
import ResultsMap from './ResultsMap';
import { useBreakpoints } from 'hooks/useBreakpoints';

const MapSearch = () => {
  const { isLessThanBreakpoint } = useBreakpoints();
  const isMobileOrTablet = isLessThanBreakpoint(1);
  const searchLimit = isMobileOrTablet ? MOBILE_MAP_SEARCH_LIMIT : DESKTOP_MAP_SEARCH_LIMIT;

  return (
    <Fragment>
      <MapSearchHelmet />
      <SearchResultFetcher limit={searchLimit} />
      <FixedPageWrapper>
        <MapWrapper>
          <ResultsMap />
        </MapWrapper>
      </FixedPageWrapper>
    </Fragment>
  );
};

export default MapSearch;
